import { yupResolver } from '@hookform/resolvers/yup';
import i18next from 'i18next';
import * as yup from 'yup';

export const delegateSchema = yupResolver(
  yup.object({
    agentId: yup.number().required(i18next.t('validation.selectUser')),
    name: yup.string().trim().defined(),
    startDate: yup.string().required(i18next.t('validation.enterStartDate')),
    endDate: yup.string().required(i18next.t('validation.enterEndDate')),
  }),
);
